var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadingButton',_vm._g(_vm._b({attrs:{"busy":_vm.busy,"disabled":_vm.disabled || _vm.busy},on:{"click":_vm.onClick}},'LoadingButton',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }